export default angular.module("ScriptLoadingService", []).factory("ScriptLoading", [
  function () {
    let progress = {
      amount: 0,
      perResource: 100 / 5,
    };
    let metadataStatus = [
      { name: "metadata", isLoaded: false },
      { name: "scriptTitles", isLoaded: false },
      { name: "scriptJS", isLoaded: false },
    ];
    let summaryRisksStatus = [
      { name: "summaryEN", isLoaded: false },
      { name: "summaryUserLang", isLoaded: false },
      { name: "risk", isLoaded: false },
    ];
    let evidenceStatus = [
      { name: "evidence", isLoaded: false },
      { name: "cochrane", isLoaded: false },
      { name: "EBMGuidelines", isLoaded: false },
      { name: "journal", isLoaded: false },
      { name: "WWWLinks", isLoaded: false },
      { name: "otherEvidence", isLoaded: false },
    ];
    let contentLogicStatus = [
      { name: "returningMessagesEN", isLoaded: false },
      { name: "returningMessagesUserLang", isLoaded: false },
      { name: "phraseAliases", isLoaded: false },
      { name: "scriptFlow", isLoaded: false },
      { name: "flowProperties", isLoaded: false },
      { name: "flowPropertyGroups", isLoaded: false },
      { name: "flowOperators", isLoaded: false },
      { name: "flowAliases", isLoaded: false },
      { name: "flowAliasGroups", isLoaded: false },
    ];
    let commentsMessagesTasksStatus = [
      { name: "messagesLinked", isLoaded: false },
    ];

    let loadingFinished = {
      value: false,
    };
    let isLoaded = {
      metadata: false,
      summaryRisks: false,
      evidence: false,
      contentLogic: false,
      commentsMessagesTasks: false,
    };

    function getProgress() {
      return progress;
    }

    function getLoadingFinished() {
      return loadingFinished;
    }

    function getIsLoaded() {
      return isLoaded;
    }

    function checkAllTrue(obj) {
      return Object.values(obj).find(v => !v) !== -1;
    }

    // Mark a resource of the Metadata group as loaded
    // resource: name of the resource as string
    function markMetadataResourceLoaded(resource) {
      metadataStatus.forEach((status) => {
        if (status.name === resource) {
          status.isLoaded = true;
          if (!isLoaded.metadata && checkAllTrue(metadataStatus)) {
            isLoaded.metadata = true;
            progress.amount += progress.perResource;
            if (!loadingFinished.value && checkAllTrue(isLoaded)) {
              loadingFinished.value = true;
            }
          }
        }
      });
    }

    // Mark a resource of the Summary & Risks group as loaded
    // resource: name of the resource as string
    function markSummaryRisksResourceLoaded(resource) {
      summaryRisksStatus.forEach((status) => {
        if (status.name === resource) {
          status.isLoaded = true;
          if (!isLoaded.summaryRisks && checkAllTrue(summaryRisksStatus)) {
            isLoaded.summaryRisks = true;
            progress.amount += progress.perResource;
            if (!loadingFinished.value && checkAllTrue(isLoaded)) {
              loadingFinished.value = true;
            }
          }
        }
      });
    }

    // Mark a resource of the Evidence group as loaded
    // resource: name of the resource as string
    function markEvidenceResourceLoaded(resource) {
      evidenceStatus.forEach((status) => {
        if (status.name === resource) {
          status.isLoaded = true;
          if (!isLoaded.evidence && checkAllTrue(evidenceStatus)) {
            isLoaded.evidence = true;
            progress.amount += progress.perResource;
            if (!loadingFinished.value && checkAllTrue(isLoaded)) {
              loadingFinished.value = true;
            }
          }
        }
      });
    }

    // Mark a resource of the Content & Logic group as loaded
    // resource: name of the resource as string
    function markContentLogicResourceLoaded(resource) {
      contentLogicStatus.forEach((status) => {
        if (status.name === resource) {
          status.isLoaded = true;
          if (!isLoaded.contentLogic && checkAllTrue(contentLogicStatus)) {
            isLoaded.contentLogic = true;
            progress.amount += progress.perResource;
            if (!loadingFinished.value && checkAllTrue(isLoaded)) {
              loadingFinished.value = true;
            }
          }
        }
      });
    }

    // Mark a resource of the Comments, Messages & Tasks group as loaded
    // resource: name of the resource as string
    function markCommentsMessagesTasksResourceLoaded(resource) {
      commentsMessagesTasksStatus.forEach((status) => {
        if (status.name === resource) {
          status.isLoaded = true;
          if (
            !isLoaded.commentsMessagesTasks &&
            checkAllTrue(commentsMessagesTasksStatus)
          ) {
            isLoaded.commentsMessagesTasks = true;
            progress.amount += progress.perResource;
            if (!loadingFinished.value && checkAllTrue(isLoaded)) {
              loadingFinished.value = true;
            }
          }
        }
      });
    }

    function startLoading(callback) {
      progress = {
        amount: 0,
        perResource: 100 / 5,
      };
      metadataStatus = [
        { name: "metadata", isLoaded: false },
        { name: "scriptTitles", isLoaded: false },
        { name: "scriptJS", isLoaded: false },
      ];
      summaryRisksStatus = [
        { name: "summaryEN", isLoaded: false },
        { name: "summaryUserLang", isLoaded: false },
        { name: "risk", isLoaded: false },
      ];
      evidenceStatus = [
        { name: "evidence", isLoaded: false },
        { name: "cochrane", isLoaded: false },
        { name: "EBMGuidelines", isLoaded: false },
        { name: "journal", isLoaded: false },
        { name: "WWWLinks", isLoaded: false },
        { name: "otherEvidence", isLoaded: false },
      ];
      contentLogicStatus = [
        { name: "returningMessagesEN", isLoaded: false },
        { name: "returningMessagesUserLang", isLoaded: false },
        { name: "phraseAliases", isLoaded: false },
        { name: "scriptFlow", isLoaded: false },
        { name: "flowProperties", isLoaded: false },
        { name: "flowPropertyGroups", isLoaded: false },
        { name: "flowOperators", isLoaded: false },
        { name: "flowAliases", isLoaded: false },
        { name: "flowAliasGroups", isLoaded: false },
      ];
      commentsMessagesTasksStatus = [
        { name: "messagesLinked", isLoaded: false },
      ];

      loadingFinished = {
        value: false,
      };
      isLoaded = {
        metadata: false,
        summaryRisks: false,
        evidence: false,
        contentLogic: false,
        commentsMessagesTasks: false,
      };
      if (callback) return callback();
    }

    return {
      getLoadingFinished,
      getIsLoaded,
      getProgress,
      markMetadataResourceLoaded,
      markSummaryRisksResourceLoaded,
      markEvidenceResourceLoaded,
      markContentLogicResourceLoaded,
      markCommentsMessagesTasksResourceLoaded,
      startLoading,
    };
  },
]);
